import { http, HttpResponse, PathParams } from 'msw';
import { AccountApiPaths } from '../../../slices/account-api.slice';
import { authenticator } from '../../data/authenticator';
import { apiUrl } from '../apiUrl';
import { composeServerError, otpHandler, validatePasswordInSettingsFlow } from './shared';

const getAuthenticator = http.get(apiUrl(AccountApiPaths.getAuthenticator), () => HttpResponse.json(authenticator));
const initNewAuthenticator = http.get(apiUrl(AccountApiPaths.initNewAuthenticator), () =>
    HttpResponse.json(authenticator)
);

const verifyPasswordToUpdateAuthenticator = http.post<PathParams, { password: string }>(
    apiUrl(AccountApiPaths.verifyPasswordToUpdateAuthenticator),
    async ({ request }) => {
        const { password } = await request.json();
        const error = validatePasswordInSettingsFlow(password);

        return error ? composeServerError(request, error) : HttpResponse.json({});
    }
);

const updateAuthenticator = http.put(apiUrl(AccountApiPaths.updateAuthenticator), otpHandler);
const verifyAuthenticatorFromSettings = http.post(apiUrl(AccountApiPaths.verifyAuthenticatorFromSettings), otpHandler);

export const changeAuthenticatorHandlers = [
    updateAuthenticator,
    verifyAuthenticatorFromSettings,
    verifyPasswordToUpdateAuthenticator,
    getAuthenticator,
    initNewAuthenticator
];
